import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ESistema } from '../../@shared/enum/ESistema';
import { Menu } from 'src/app/@shared/models/menu.model';
import { StorageService } from '../storage/storage.service';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})


export class MenuItemsService {
  sistema: ESistema;
  constructor(private http: HttpClient) { }

  getMenus(): Observable<Menu[]> {
    
    return this.http.get<Menu[]>(`PerfilAcesso/ListarMenuAcesso/${ESistema.Vesta}`, httpOptions);
  }
}
